import React, { useEffect, useState } from "react";
import { withLayout } from "../../layout";
import EuiTile from "../../eui-components/tile";
import EuiCard from "../../eui-components/card";
import EuiTextField from "../../eui-components/textfield";
import EuiSelect from "../../eui-components/select";
import EuiRow from "../../eui-components/row";
import ApiHelper from "../../utils/api-helper";
import withClearCache from "../../ClearCache";
import { connect, useDispatch, useSelector } from "react-redux";
import EuiLoading from "../../eui-components/loading";
import DialogModal from "../../components/dialog";
import UserHelper from "../../utils/user-helper";
import ApiClient from "../../utils/api-client";
import CommonHelper from "../../utils/common-helper";
import AutoAssignmentHelper from "../../utils/auto-assignment-helper";
import constants from "../../utils/constants";
import UserAdminHelper from "../../utils/user-admin-helper";

const Home = (props) => {

    const navBarView = useSelector(state => state.navigation.navBarView);
    const jobRole = useSelector(state => state.user.userData.jobRole);
    const checkin = useSelector(state => state.user.rscPerson?.checkin);
    const rscPerson = useSelector(state => state.user.rscPerson);
    const userRefresfred = useSelector(state => state.user.userRefreshed);
    const [isLoading, setIsLoading] = useState(false);
    const [openCheckinDialog, setOpenCheckinDialog] = useState(UserHelper.isRscInspector(jobRole) && !checkin);
    const [ISEritopUser, setISEritopUser] = useState(true)
    const [openRequestAccessDialog, setOpenRequestAccessDialog] = useState(false);
    const [openSetupCompanyDialog, setOpenSetupCompanyDialog] = useState(false);
    const [adminContacts, setAdminContacts] = useState([]);
    const [openCreateCompanyDialog, setOpenCreateCompanyDialog] = useState(false);
    const [newCompany, setNewCompany] = useState({ name: "", aspShortName: "", countryId: "", address: "", contactPerson: "", email: "", phone: "", vendorId: "" });
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();


    useEffect(() => {
        if (!navBarView) {
            dispatch({ type: "TOGGLE_NAVBAR" });
        }

        async function fetchCountriesAndUsers() {
            await ApiHelper.setCountriesWithDetails((data) => dispatch({ type: "SET_ALL_COUNTRIES", payload: data }), (data) => dispatch({ type: "SET_ALL_CUSTOMERS", payload: data }));
            await ApiHelper.setAllUsers((data) => dispatch({ type: "SET_ALL_USERS", payload: data }));
        }

        setIsLoading(true);
        fetchCountriesAndUsers();
        setIsLoading(false);

        setISEritopUser(!user?.userDetail?.loginComment)
    }, []);

    useEffect(() => {
        // if (!userRefresfred)  // refresh user data atleast one time in backgroud i.e if someone updated db , this is to avoid force cache clean
        setTimeout(() => {
            refreshAllUserDataInBackgroudAsync()
        }, 0);

    }, [userRefresfred])


    const refreshAllUserDataInBackgroudAsync = async () => {
        return ApiHelper.refreshAllUserDataInBackgroud(props.setUserLoginRoles, props.setRscCenters, props.login, props.setWebToken, props.setUserRefreshed,props.user.userData.jobRole);
    }


    // const refreshAllUserDataInBackgroud = () => {
    //     ApiClient.post("UserAdmin/GetUserLoginRoles")
    //         .then(response => {
    //             props.setUserLoginRoles(response.data);
    //             ApiClient.post("UserAdmin/GetRscCenters")
    //                 .then(response => {
    //                     const rscCenters = response.data;
    //                     if (rscCenters) {
    //                         rscCenters.map(r => {
    //                             r.value = r.id;
    //                             r.text = r.name;
    //                         });
    //                     }
    //                     props.setRscCenters(rscCenters);
    //                     fetchUSerDetail()
    //                 }).catch(error => {
    //                     console.error(error);

    //                 });
    //         }).catch(error => {
    //             console.error(error);

    //         });
    // }

    const fetchUSerDetail = () => {


        const onSuccess = (response) => {

            props.setWebToken(response.data.user?.webToken);
            const loginUser = UserAdminHelper.mapLoginUser(response.data, props.userAdminData.loginRoles, props?.user?.rscCenters);
            loginUser.rememberMe = true;

            props.login(loginUser);
            props.setUserRefreshed(true)

            // setTimeout(() => this.props.history.push("/"), 1000);

        };
        const onError = (error) => {
            console.error(error);

        };
        ApiClient.post("User/GetUserConfig", { includeEveryThing: true }).then(onSuccess).catch(onError);
    };
    const checkinCheckout = () => {

        var request = {
            rscPersonId: rscPerson.id,
            checkin: true,
        };
        setIsLoading(true);
        ApiClient.post("AutoAssignment/CheckinCheckout", request)
            .then(response => {
                if (response.data) {
                    ApiClient.checked(request);
                    AutoAssignmentHelper.mapRscPerson(response.data);
                    dispatch({ type: "SET_RSC_PERSON", payload: { ...rscPerson, ...response.data } });
                    setOpenCheckinDialog(false);
                    setIsLoading(false);
                } else {
                    CommonHelper.createNotification({ title: response.data.errorDetail, icon: "cross" });
                }
            })
            .catch(error => {
                CommonHelper.createNotification({ title: constants.errorMessage, icon: "cross" });
                console.error(error);;
            });
    }

    const fetchAdminContacts = () => {
        ApiClient.post("UserAdmin/GetAdminContacts")
            .then(response => {
                setAdminContacts(response.data ?? []);
            })
            .catch(error => {
                CommonHelper.createNotification({ title: constants.errorMessage, icon: "cross" });
                console.error(error);
            });
    }

    const openRequestUserAccess = () => {
        fetchAdminContacts();
        setOpenRequestAccessDialog(true);
    }

    const openSetupAspCompany = () => {
        fetchAdminContacts();
        setOpenSetupCompanyDialog(true);
    }

    const updateNewCompany = (event) => setNewCompany({ ...newCompany, [event.target.name]: event.target.value });

    const createAspCompany = () => {
        if (Object.values(newCompany).some(value => !String(value).trim())) {
            CommonHelper.createNotification({ title: "Please complete all required fields.", icon: "cross" });
            return;
        }
        setIsLoading(true);
        ApiClient.post("Asp/CreateAspCompany", { ...newCompany, countryId: Number(newCompany.countryId) })
            .then(response => {
                if (!response.data?.success) {
                    CommonHelper.createNotification({ title: response.data?.errorMessage || constants.errorMessage, icon: "cross" });
                    return;
                }
                CommonHelper.createNotification({ title: "ASP company created successfully.", icon: "check" });
                setOpenCreateCompanyDialog(false);
                setNewCompany({ name: "", aspShortName: "", countryId: "", address: "", contactPerson: "", email: "", phone: "", vendorId: "" });
            })
            .catch(error => {
                CommonHelper.createNotification({ title: constants.errorMessage, icon: "cross" });
                console.error(error);
            })
            .finally(() => setIsLoading(false));
    }

    const renderAdminContactsList = () => {
        if (!adminContacts.length) {
            return <div>Loading admin contact details...</div>;
        }
        return (
            <ul style={{ paddingLeft: 20 }}>
                {adminContacts.map(admin => (
                    <li key={admin.userId}>
                        {admin.name} - <a href={`mailto:${admin.mail}`}>{admin.mail}</a>
                    </li>
                ))}
            </ul>
        );
    }

    const renderHomeOptions = () => {
        return (
            <>
                <EuiTile fullscreen contentClassName="mt-4" title="Overview" headerStyle={{ paddingBottom: 12 }} titleClassName="ml-1">
                    <p className="ml-1">Choose an option below to request access or set up an ASP company.</p>
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 280px), 450px))",
                        gap: 16,
                        padding: "16px 4px"
                    }}>
                        <div>
                            <EuiCard id="requestUserAccessCard"
                                title="Request User Access"
                                titleStyle={{ fontSize: 16 }}
                                content={<div style={{ color: "gray", display: "flex", flexDirection: "column", minHeight: 120 }}>
                                    <p style={{ flex: 1 }}>Contact an administrator to request access to the application.</p>
                                    <p style={{ marginBottom: 0 }}>
                                        <button className="btn primary" onClick={openRequestUserAccess}><i className="icon icon-launch" style={{ marginRight: 10 }}></i>Go</button>
                                    </p>
                                </div>}
                                style={{ height: "100%", minHeight: 180 }}
                            />
                        </div>
                        <div>
                            <EuiCard id="setupAspCompanyCard"
                                title="Setup ASP Company"
                                titleStyle={{ fontSize: 16 }}
                                content={<div style={{ color: "gray", display: "flex", flexDirection: "column", minHeight: 120 }}>
                                    <p style={{ flex: 1 }}>View instructions to set up your ASP company.</p>
                                    <p style={{ marginBottom: 0 }}>
                                        <button className="btn primary" onClick={openSetupAspCompany}><i className="icon icon-launch" style={{ marginRight: 10 }}></i>Go</button>
                                    </p>
                                </div>}
                                style={{ height: "100%", minHeight: 180 }}
                            />
                        </div>
                        {user?.userDetail?.eritopVo && <div>
                            <EuiCard id="createAspCompanyCard"
                                title="Add ASP Company"
                                titleStyle={{ fontSize: 16 }}
                                content={<div style={{ color: "gray", display: "flex", flexDirection: "column", minHeight: 120 }}>
                                    <p style={{ flex: 1 }}>Create a new ASP company with its required contact and vendor information.</p>
                                    <p style={{ marginBottom: 0 }}>
                                        <button className="btn primary" onClick={() => setOpenCreateCompanyDialog(true)}><i className="icon icon-plus" style={{ marginRight: 10 }}></i>Add</button>
                                    </p>
                                </div>}
                                style={{ height: "100%", minHeight: 180 }}
                            />
                        </div>}
                    </div>
                </EuiTile>

                <DialogModal
                    buttonName="Create"
                    content={<form className="form" onSubmit={event => { event.preventDefault(); createAspCompany(); }}>
                        <EuiRow>
                            <div className="column sm-12 md-6 lg-6 xl-6 filled">
                                <div className="form-group mb-2"><EuiTextField required fullwidth className="w-10" style={{ width: "100%" }} id="newAspName" name="name" label="Company Name" labelClass="required" value={newCompany.name} onChange={updateNewCompany} /></div>
                                <div className="form-group mb-2"><EuiTextField required fullwidth className="w-10" style={{ width: "100%" }} id="newAspShortName" name="aspShortName" label="Short Name" labelClass="required" value={newCompany.aspShortName} onChange={updateNewCompany} /></div>
                                <div className="form-group mb-2">
                                    <label className="required" style={{ color: "gray", fontSize: 14 }} htmlFor="newAspCountry">Country</label>
                                    <EuiSelect id="newAspCountry" name="countryId" label="---Select Country---" style={{ width: "100%" }} options={[{ value: "", text: "---Select Country---" }, ...(user?.countries || [])]} value={newCompany.countryId} onChange={updateNewCompany} />
                                </div>
                                <div className="form-group mb-2"><EuiTextField required fullwidth className="w-10" style={{ width: "100%" }} id="newAspVendorId" name="vendorId" label="Vendor ID" labelClass="required" value={newCompany.vendorId} onChange={updateNewCompany} /></div>
                            </div>
                            <div className="column sm-12 md-6 lg-6 xl-6 filled">
                                <div className="form-group mb-2"><EuiTextField required fullwidth className="w-10" style={{ width: "100%" }} id="newAspContact" name="contactPerson" label="Contact Person" labelClass="required" value={newCompany.contactPerson} onChange={updateNewCompany} /></div>
                                <div className="form-group mb-2"><EuiTextField required fullwidth className="w-10" style={{ width: "100%" }} type="email" id="newAspEmail" name="email" label="Email" labelClass="required" value={newCompany.email} onChange={updateNewCompany} /></div>
                                <div className="form-group mb-2"><EuiTextField required fullwidth className="w-10" style={{ width: "100%" }} id="newAspPhone" name="phone" label="Phone" labelClass="required" value={newCompany.phone} onChange={updateNewCompany} /></div>
                                <div className="form-group mb-2"><EuiTextField required fullwidth className="w-10" style={{ width: "100%" }} id="newAspAddress" name="address" label="Address" labelClass="required" value={newCompany.address} onChange={updateNewCompany} /></div>
                            </div>
                        </EuiRow>
                    </form>}
                    handleClose={() => setOpenCreateCompanyDialog(false)}
                    id="createAspCompanyDialogId"
                    onClick={createAspCompany}
                    open={openCreateCompanyDialog}
                    fullWidth
                    contentStyle={{ paddingTop: 4 }}
                    title="Add ASP Company"
                />

                <DialogModal
                    buttonsVisible="false"
                    content={renderAdminContactsList()}
                    handleClose={() => setOpenRequestAccessDialog(false)}
                    id="requestUserAccessDialogId"
                    open={openRequestAccessDialog}
                    title="Request User Access"
                >
                </DialogModal>

                <DialogModal
                    buttonsVisible="false"
                    content={
                        <div>
                            <ol style={{ paddingLeft: 20 }}>
                                <li>Contact one of the admins listed below to request an ASP Company be created.</li>
                                <li>Provide your ASP Company name, country and a designated ASP Project Manager.</li>
                                
                            </ol>
                            <h4>Admin Contacts</h4>
                            {renderAdminContactsList()}
                        </div>
                    }
                    handleClose={() => setOpenSetupCompanyDialog(false)}
                    id="setupAspCompanyDialogId"
                    open={openSetupCompanyDialog}
                    title="Setup ASP Company Instructions"
                >
                </DialogModal>
            </>
        );
    }
    const renderModNotEritopUser = () => {
        return (
            <>
                <EuiLoading id="checkinCheckOutLoading" isLoading={isLoading} />
                <div className="ml-1" style={{ color: 'red', whiteSpace: 'pre-wrap' }}>{user?.userDetail?.loginComment}</div>
                {renderHomeOptions()}
            </>
        );
    }
    const renderMod = () => {
        return (
            <>
                <EuiLoading id="checkinCheckOutLoading" isLoading={isLoading} />
                <DialogModal
                    buttonName="Confirm"
                    content={<div>{"Please confirm your check-in for Activities/EHS pings Auto-Assignment"} </div>}
                    handleClose={() => setOpenCheckinDialog(false)}
                    id="checkinDialogId"
                    onClick={() => checkinCheckout()}
                    open={openCheckinDialog}
                    title="Check-In to Auto-Assignment"
                >
                </DialogModal>
                {renderHomeOptions()}
            </>
        );
    }
    return (
        <>
            {ISEritopUser ? renderMod() : renderModNotEritopUser()}
        </>
    );
}

const mapStateToProps = state => ({ user: state.user, userAdminData: state.userAdmin });
const mapDispatchToProps = dispatch => {
    return {
        passwordReset: () => dispatch({ type: "RESET_PASSWORD" }),
        login: (loginUser) => dispatch({ type: "LOGIN", payload: loginUser }),
        setUserLoginRoles: (loginRoles) => dispatch({ type: "SET_USER_LOGIN_ROLES", payload: loginRoles }),
        setRscCenters: (rscCnters) => dispatch({ type: "SET_RSC_CENTERS", payload: rscCnters }),
        setWebToken: (webToken) => dispatch({ type: "SET_WEB_TOKEN", payload: webToken }),
        setUserRefreshed: (userRefreshed) => dispatch({ type: "SET_USER_REFRESHED", payload: userRefreshed }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withLayout(withClearCache(Home)));


